var domain = window.location.host;
var FUNCTIONAL = 2;

var handleConsentDecision = function (consent) {
  let hasConsent = false;

  if (consent.source === "asserted") {
    hasConsent = consent.consentDecision.includes(FUNCTIONAL);
  } else if (consent.source === "implied") {
    hasConsent = !(
      truste.eu &&
      truste.eu.bindMap &&
      truste.eu.bindMap.behaviorManager.includes("eu")
    );
  }

  if (typeof mixpanel !== "undefined" && mixpanel) {
    if (hasConsent) {
      mixpanel.opt_in_tracking();
    } else {
      mixpanel.opt_out_tracking();
    }
  } else {
    console.warn("Mixpanel is not defined.");
  }
};

var interval = setInterval(function () {
  if (window.truste && window.truste.cma && window.truste.cma.callApi) {
    var consentDecision = window.truste.cma.callApi(
      "getGDPRConsentDecision",
      domain
    );
    handleConsentDecision(consentDecision);
    clearInterval(interval);
  }
}, 100);

window.addEventListener(
  "message",
  function (event) {
    var eventDataJson = null;
    try {
      eventDataJson = JSON.parse(event.data);
    } catch (e) {}

    if (
      eventDataJson &&
      eventDataJson.source === "preference_manager" &&
      eventDataJson.message === "submit_preferences"
    ) {
      setTimeout(function () {
        var consentDecision = window.truste.cma.callApi(
          "getGDPRConsentDecision",
          domain
        );
        handleConsentDecision(consentDecision);
      }, 500);
    }
  },
  false
);
